<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import ApplyForRequisition from '../common/ApplyForRequisition/index.vue';
import CodeAssignmentDetails from '../common/CodeAssignmentDetails/index.vue';
export default {
	components: {
		ApplyForRequisition,
		CodeAssignmentDetails,
	},
	data() {
		return {
			//表格
			size: 'mini',
			shaidiag: false,
			headData: JSON.parse(localStorage.getItem('CodeManagementheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('CodeManagementoutlist')) || [],
			pagination: getdata().pagination, //分页数据
			tableData: [
				{
					invoiceBegin: '23157000000002168072',
					invoiceEnd: '23157000000002168072',
					receiveCount: '123',
					inventoryInvoiceBegin: '23157000000002168072',
					inventoryInvoiceEnd: '23157000000002168072',
					inventoryCount: '321',
					thatYearInvoice: '0',
					applyDate: '2022年1月1日',
					applyResult: '0',
					errorInfo: ''
				},	{
					invoiceBegin: '23157000000000046826',
					invoiceEnd: '23157000000000046835',
					receiveCount: '321',
					inventoryInvoiceBegin: '23157000000000046826',
					inventoryInvoiceEnd: '23157000000000046835',
					inventoryCount: '123',
					thatYearInvoice: '0',
					applyDate: '2022年1月1日',
					applyResult: '1',
					errorInfo: ''
				},
			], //表格内容数据
			//筛选字段
			param: {
				isCurrentYearInvoice: ['0', '1'],
				applyDate: [],
				applyResult: ['0', '1']
			},
			tablekey: 0,
			//申请领用
			sqdiag: false,
			//赋码详情
			codedetailDiag: false,
			//排序字段
			order: '',
			//排序顺序
			sort: '',
			//配置数据
			configData: {
				applyCredit: 0,
				autoApplyCredit: false,
				threshold: 0
			},
			//主表id
			id:"",
			isdisabled:true
		};
	},
	mounted() {},
	created() {
		this.initialization();
	},
	methods: {
		//时间撮转时间yyyymmmdd
		timestampToTime(timestamp) {
			var date = new Date(timestamp);
			var Y = date.getFullYear() + '年';
			var M = (date.getMonth() + 1 < 10 ? date.getMonth() + 1 : date.getMonth() + 1) + '月';
			var D = (date.getDate() < 10 ? date.getDate() : date.getDate()) + '日 ';
			return Y + M + D;
		},
		//时间撮转时间
		timestampToTimesfm(timestamp) {
			var date = new Date(timestamp);
			var Y = date.getFullYear() + '年';
			var M = (date.getMonth() + 1 < 10 ? date.getMonth() + 1 : date.getMonth() + 1) + '月';
			var D = (date.getDate() < 10 ? date.getDate() : date.getDate()) + '日 ';
			var h = date.getHours() + ':';
			var m = date.getMinutes() + ':';
			var s = date.getSeconds();
			return Y + M + D + h + m + s;
		},
		//配置保存
		ConfigurationSave() {
			let data = {
				applyCredit: this.configData.applyCredit,
				autoApplyCredit: this.configData.autoApplyCredit ? '1' : '0',
				threshold: this.configData.threshold
			};
			this.$https.fetchPost('/natural/codeAssignment/operatorCodeAssignmentConfig', data).then(res => {
				if (res.data.code == '200') {
					this.$message.success(res.data.message);
					this.initialization();
					this.isdisabled=true
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//初始化
		initialization() {
			let params = {};
			params.limit = this.pagination.pageSize;
			params.page = this.pagination.pageNum;
			params.sort = this.sort;
			params.order = this.order;
			params.param = this.param;
			this.$https.fetchPost('/natural/codeAssignment/findCodeAssignment', params).then(res => {
				this.tableData = res.data.data;
				this.pagination.total = res.data.count;
				this.$https.fetchPost('/natural/codeAssignment/findCodeAssignmentConfig').then(res => {
					this.configData = res.data.data;
					this.configData.autoApplyCredit = res.data.data.autoApplyCredit == '1' ? true : false;
				});
			});
		},
		//申请领用
		closesqdiag() {
			this.sqdiag = false;
			this.initialization();
		},
		forsqdiag() {
			this.sqdiag = true;
		},
		//赋码详情
		closescodedetailDiag() {
			this.codedetailDiag = false;
		},
		//查看赋码详情
		forcodedetailDiag(id) {
			this.id=id
			console.log(id)
			this.codedetailDiag = true;
		},
		//表格体 排序
		sortchange(e) {
			if (e.order != null) {
				this.sort = e.order == 'ascending' ? 'ASC' : 'DESC';
				this.order = e.prop;
			} else {
				this.sort = '';
				this.order = '';
			}
			this.initialization();
		}, //筛选数组
		forSearchScreeningBox(obj) {
			this.param = obj;
			this.param.isCurrentYearInvoice = obj.thatYearInvoice;
			this.initialization();
		},
		//分页
		currentChange(e) {
			this.pagination.pageNum = e;
			this.initialization();
		},
		//行数
		sizechange(e) {
			this.pagination.pageSize = e;
			this.initialization();
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('CodeManagementoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('CodeManagementheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
